module.exports = __webpack_public_path__ + "static/media/img-bienvenido.f293543c.jpg";